/* DUNKPOINT product page: "Product only" / "Bundle" tabs and the bundle builder.
   The bundle prices itself against the store's automatic "buy X, get Y free"
   discount (X and Y come from the theme settings): for every X + Y items the
   lowest-priced Y are free. Everything is added with one /cart/add.js call and
   the existing cart drawer opens the same way a normal add does. */
(function () {
  'use strict';

  /* ---------------------------------------------------------- money ---- */
  /* The page renders 1234.56 in the visitor's currency; reuse its symbol,
     separators and decimals so bundle totals look like every other price. */
  function moneyFormatter(sample) {
    var m = String(sample || '').match(/1(\D?)23(\d)(?:(\D)(\d{2}))?/);
    if (!m) return function (cents) { return (cents / 100).toFixed(2); };
    var thousands = m[1];
    var decimal = m[3] || '';
    var decimals = m[3] ? 2 : 0;
    var before = sample.slice(0, m.index);
    var after = sample.slice(m.index + m[0].length);
    return function (cents) {
      var fixed = (cents / 100).toFixed(decimals).split('.');
      var head = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return before + head + (decimals ? decimal + fixed[1] : '') + after;
    };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (all, key) { return key in map ? map[key] : all; });
  }

  /* ----------------------------------------------------------- tabs ---- */
  function setupTabs(buy) {
    if (buy.dataset.dpBuyReady) return;
    buy.dataset.dpBuyReady = '1';
    var tabs = Array.prototype.slice.call(buy.querySelectorAll('[data-dp-buy-tab]'));
    var panels = Array.prototype.slice.call(buy.querySelectorAll('[data-dp-buy-panel]'));

    function select(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-dp-buy-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-dp-buy-panel') !== name; });
      buy.setAttribute('data-active', name);
      if (name === 'bundle') {
        var box = buy.querySelector('[data-dp-pbundle]');
        if (box && box.dpSync) box.dpSync();
      }
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-dp-buy-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next.getAttribute('data-dp-buy-tab'), true);
      });
    });
  }

  /* --------------------------------------------------------- bundle ---- */
  function setupBundle(box) {
    if (box.dataset.dpPbnReady) return;
    var data;
    try { data = JSON.parse(box.querySelector('[data-dp-pbn-data]').textContent); } catch (e) { return; }
    box.dataset.dpPbnReady = '1';

    var buyQty = Math.max(1, Number(box.dataset.buy) || 2);
    var getQty = Math.max(1, Number(box.dataset.get) || 1);
    var setSize = buyQty + getQty;
    var money = moneyFormatter(data.moneySample);
    var S = data.strings || {};
    var main = data.main;
    var pool = (data.pool || []).filter(function (p) { return p && p.variants && p.variants.length; });
    if (!main || !main.variants.length) return;

    var pdp = box.closest('[data-dp-pdp]');
    var mainInput = pdp && pdp.querySelector('[data-dp-variant-input]');
    var mainTouched = false;

    function variantById(product, id) {
      return product.variants.filter(function (v) { return String(v.id) === String(id); })[0];
    }

    /* The available variant that keeps the most of the wanted option values
       (matched by option name, e.g. the same size as the main product). */
    function bestVariant(product, wanted) {
      var best = product.variants[0];
      var bestScore = -1;
      product.variants.forEach(function (v) {
        var score = 0;
        product.options.forEach(function (name, i) {
          if (wanted[name] != null && wanted[name] === v.o[i]) score++;
        });
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }

    function valuesOf(product, variant) {
      var map = {};
      product.options.forEach(function (name, i) { map[name] = variant.o[i]; });
      return map;
    }

    function mainLine() {
      var v = variantById(main, data.mainVariant) || main.variants[0];
      return { product: main, variant: v, isMain: true, poolIndex: -1 };
    }

    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-dp-pbn-card]')).map(function (el) {
      var count = Math.max(2, Number(el.getAttribute('data-count')) || setSize);
      var lines = [mainLine()];
      var wanted = valuesOf(main, lines[0].variant);
      for (var i = 0; i < count - 1 && i < pool.length; i++) {
        lines.push({ product: pool[i], variant: bestVariant(pool[i], wanted), isMain: false, poolIndex: i });
      }
      var strip = el.querySelector('[data-dp-pbn-strip]');
      if (!strip) {
        strip = document.createElement('div');
        strip.className = 'dp-pbn__strip';
        strip.setAttribute('data-dp-pbn-strip', '');
        strip.setAttribute('aria-hidden', 'true');
        el.querySelector('[data-dp-pbn-lines]').before(strip);
      }
      return {
        el: el,
        count: lines.length,
        lines: lines,
        head: el.querySelector('[data-dp-pbn-pick]'),
        list: el.querySelector('[data-dp-pbn-lines]'),
        strip: strip,
        regular: el.querySelector('[data-dp-pbn-regular]'),
        total: el.querySelector('[data-dp-pbn-total]')
      };
    });
    var selected = cards[0];

    /* For every full set of X + Y items, the lowest-priced Y are free. */
    function price(card) {
      var n = card.lines.length;
      var freeCount = Math.floor(n / setSize) * getQty;
      var order = card.lines.map(function (l, i) { return i; }).sort(function (a, b) {
        return card.lines[a].variant.p - card.lines[b].variant.p || b - a;
      });
      var free = {};
      order.slice(0, freeCount).forEach(function (i) { free[i] = true; });
      var regular = 0, off = 0;
      card.lines.forEach(function (l, i) {
        regular += l.variant.p;
        if (free[i]) off += l.variant.p;
      });
      return { n: n, pay: n - freeCount, free: free, regular: regular, off: off, total: regular - off };
    }

    function optionValues(product, i) {
      var seen = {}, list = [];
      product.variants.forEach(function (v) { if (!seen[v.o[i]]) { seen[v.o[i]] = true; list.push(v.o[i]); } });
      return list;
    }

    function lineHtml(card, line, index, totals) {
      var p = line.product;
      var selects = '';
      p.options.forEach(function (name, i) {
        var values = optionValues(p, i);
        if (values.length < 2) return;
        /* Only available variants are in the data, so every value listed can
           be bought; picking one keeps as many of the other choices as it can. */
        var opts = values.map(function (val) {
          return '<option value="' + esc(val) + '"' + (val === line.variant.o[i] ? ' selected' : '') + '>' + esc(val) + '</option>';
        }).join('');
        selects += '<label class="dp-pbn__opt"><span class="dp-pbn__opt-name">' + esc(name) + '</span>' +
          '<select data-dp-pbn-opt="' + i + '" aria-label="' + esc(name + ': ' + p.title) + '">' + opts + '</select></label>';
      });
      var canSwap = !line.isMain && pool.length > card.lines.length - 1;
      var isFree = !!totals.free[index];
      return '<div class="dp-pbn__line' + (isFree ? ' is-free' : '') + '" data-dp-pbn-line="' + index + '">' +
        '<a class="dp-pbn__thumb" href="' + esc(p.url) + '" tabindex="-1">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
        '<div class="dp-pbn__info">' +
          '<p class="dp-pbn__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            (line.isMain && S.thisItem ? ' <span class="dp-pbn__this">' + esc(S.thisItem) + '</span>' : '') + '</p>' +
          (selects ? '<div class="dp-pbn__opts">' + selects + '</div>' : '') +
          '<p class="dp-pbn__lprice">' +
            (isFree ? '<s>' + esc(money(line.variant.p)) + '</s> <span class="dp-pbn__free">' + esc(S.free || '') + '</span>'
                    : '<span>' + esc(money(line.variant.p)) + '</span>') +
          '</p>' +
        '</div>' +
        (canSwap ? '<button type="button" class="dp-pbn__swap" data-dp-pbn-swap aria-label="' + esc((S.swap || '') + ': ' + p.title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 4 3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7"/></svg>' +
          '<span>' + esc(S.swap || '') + '</span></button>' : '') +
      '</div>';
    }

    function renderCard(card) {
      var totals = price(card);
      card.list.innerHTML = card.lines.map(function (l, i) { return lineHtml(card, l, i, totals); }).join('');
      card.strip.innerHTML = card.lines.map(function (l) {
        return l.product.img ? '<img src="' + esc(l.product.img) + '" alt="" width="40" height="40" loading="lazy">' : '<span></span>';
      }).join('');
      if (card.regular) card.regular.textContent = totals.off ? money(totals.regular) : '';
      if (card.total) card.total.textContent = money(totals.total);
      return totals;
    }

    var els = {
      sumRegLabel: box.querySelector('[data-dp-pbn-regular-label]'),
      sumReg: box.querySelector('[data-dp-pbn-sum-regular]'),
      sumOff: box.querySelector('[data-dp-pbn-sum-off]'),
      sumTotal: box.querySelector('[data-dp-pbn-sum-total]'),
      tag: box.querySelector('[data-dp-pbn-tag]'),
      saving: box.querySelector('[data-dp-pbn-saving]'),
      add: box.querySelector('[data-dp-pbn-add]'),
      error: box.querySelector('[data-dp-pbn-error]')
    };

    function render() {
      var chosen = null;
      cards.forEach(function (card) {
        var t = renderCard(card);
        var on = card === selected;
        if (on) chosen = t;
        card.el.classList.toggle('is-selected', on);
        card.head.setAttribute('aria-checked', on ? 'true' : 'false');
        if (card.head.hasAttribute('aria-expanded')) card.head.setAttribute('aria-expanded', on ? 'true' : 'false');
        card.list.hidden = !on;
        card.strip.hidden = on;
      });
      var map = { n: chosen.n, pay: chosen.pay };
      if (els.sumRegLabel) els.sumRegLabel.textContent = fill(els.sumRegLabel.getAttribute('data-template'), map);
      if (els.sumReg) els.sumReg.textContent = money(chosen.regular);
      if (els.sumOff) els.sumOff.textContent = (chosen.off ? '- ' : '') + money(chosen.off);
      if (els.sumTotal) els.sumTotal.textContent = money(chosen.total);
      if (els.tag) els.tag.textContent = fill(S.tag, map);
      if (els.saving) {
        els.saving.hidden = !chosen.off;
        els.saving.textContent = fill(els.saving.getAttribute('data-template'), { amount: money(chosen.off) });
      }
    }

    /* Keep the main line on the variant chosen in the normal form until the
       shopper changes it inside the bundle. */
    box.dpSync = function () {
      if (mainTouched || !mainInput) return;
      var v = variantById(main, mainInput.value);
      if (!v) return;
      cards.forEach(function (card) { card.lines[0].variant = v; });
      render();
    };

    box.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-dp-pbn-opt]');
      if (!sel) return;
      var lineEl = sel.closest('[data-dp-pbn-line]');
      var card = cards.filter(function (c) { return c.el.contains(lineEl); })[0];
      var line = card.lines[Number(lineEl.getAttribute('data-dp-pbn-line'))];
      var i = Number(sel.getAttribute('data-dp-pbn-opt'));
      var wanted = valuesOf(line.product, line.variant);
      wanted[line.product.options[i]] = sel.value;
      var withValue = { product: line.product, variants: line.product.variants.filter(function (v) { return v.o[i] === sel.value; }), options: line.product.options };
      if (!withValue.variants.length) return;
      line.variant = bestVariant(withValue, wanted);
      if (line.isMain) mainTouched = true;
      render();
      var again = box.querySelector('[data-dp-pbn-card="' + card.el.getAttribute('data-dp-pbn-card') + '"] [data-dp-pbn-line="' + lineEl.getAttribute('data-dp-pbn-line') + '"] [data-dp-pbn-opt="' + i + '"]');
      if (again) again.focus();
    });

    box.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-dp-pbn-pick]');
      if (pick) {
        selected = cards.filter(function (c) { return c.head === pick; })[0] || selected;
        render();
        return;
      }
      var swap = e.target.closest('[data-dp-pbn-swap]');
      if (swap) {
        var lineEl = swap.closest('[data-dp-pbn-line]');
        var index = Number(lineEl.getAttribute('data-dp-pbn-line'));
        var card = cards.filter(function (c) { return c.el.contains(lineEl); })[0];
        var line = card.lines[index];
        var used = {};
        card.lines.forEach(function (l) { if (!l.isMain) used[l.poolIndex] = true; });
        for (var step = 1; step <= pool.length; step++) {
          var next = (line.poolIndex + step) % pool.length;
          if (used[next]) continue;
          var wanted = valuesOf(line.product, line.variant);
          line.product = pool[next];
          line.poolIndex = next;
          line.variant = bestVariant(pool[next], wanted);
          break;
        }
        render();
        var again = card.list.querySelector('[data-dp-pbn-line="' + index + '"] [data-dp-pbn-swap]');
        if (again) again.focus();
        return;
      }
      if (e.target.closest('[data-dp-pbn-add]')) addToCart();
    });

    function openDrawer() {
      if (document.querySelector('[data-dp-cart]')) {
        /* assets/dp-cart.js opens (and reloads) the drawer for any click on a
           [data-dp-cart-open] element; reloading fires dp:cart:updated. */
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.hidden = true;
        trigger.setAttribute('data-dp-cart-open', '');
        document.body.appendChild(trigger);
        trigger.click();
        trigger.remove();
        return;
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try { document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: { cart: cart } })); } catch (err) {}
        })
        .catch(function () {})
        .then(function () { window.location.href = '/cart'; });
    }

    var busy = false;
    function addToCart() {
      if (busy) return;
      busy = true;
      var qty = {}, order = [];
      selected.lines.forEach(function (l) {
        if (!qty[l.variant.id]) { qty[l.variant.id] = 0; order.push(l.variant.id); }
        qty[l.variant.id]++;
      });
      var items = order.map(function (id) { return { id: id, quantity: qty[id] }; });
      els.add.disabled = true;
      els.add.setAttribute('aria-busy', 'true');
      els.error.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || (res.data && res.data.status && res.data.status !== 200)) throw new Error('add');
          openDrawer();
        })
        .catch(function () { els.error.hidden = false; })
        .then(function () {
          busy = false;
          els.add.disabled = false;
          els.add.removeAttribute('aria-busy');
        });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-dp-buy]').forEach(setupTabs);
    document.querySelectorAll('[data-dp-pbundle]').forEach(setupBundle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
